import PropTypes from 'prop-types';

export const propTypes = {
  openKeyRentalFactsModal: PropTypes.func,
  hasKeyFactsPolicies: PropTypes.bool,
};
